import { SvgIconProps } from "@mui/material/SvgIcon";
import { ThemedFillSvgIcon } from "src/theme-mui/components/svg-icon/themed-fill-svg-icon";

export const IconPlay = (props: SvgIconProps) => (
    <ThemedFillSvgIcon {...props} viewBox="0 0 80 80">
        <path
            id="icon play"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40 0C17.9378 0 0 17.9378 0 40C0 62.0622 17.9378 80 40 80C62.0622 80 80 62.0622 80 40C80 17.9378 62.0622 0 40 0ZM40 4.89236C59.4169 4.89236 75.1076 20.583 75.1076 39.9999C75.1076 59.4168 59.4169 75.1075 40 75.1075C20.5831 75.1075 4.89244 59.4168 4.89244 39.9999C4.89244 20.583 20.5831 4.89236 40 4.89236ZM34.7384 20.192C33.2639 19.0164 31.084 20.0663 31.084 21.9521V58.0491C31.084 59.9349 33.2638 60.9848 34.7384 59.8092L57.3759 41.7611C58.5062 40.8599 58.5062 39.1421 57.3759 38.2408L34.7384 20.192Z"
            fill="white"
        />
    </ThemedFillSvgIcon>
);
